var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPerCustomerPrice = function SvgPerCustomerPrice(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FF4A4A",
    d: "M6 0h20a6 6 0 0 1 6 6v20a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero",
    stroke: "#FFF",
    strokeDasharray: "0,0",
    strokeWidth: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.84 13.07 19 10.61a.37.37 0 0 0-.28-.61h-.56a.35.35 0 0 0-.27.12l-1.54 1.76a.365.365 0 0 1-.55 0l-1.54-1.76a.35.35 0 0 0-.27-.12h-.56a.37.37 0 0 0-.28.61l2.16 2.46h-1.94a.373.373 0 0 0-.37.37v.03c0 .202.168.37.37.37h1.94v1.54h-1.94a.365.365 0 0 0-.37.36v.04c0 .202.168.36.37.36h1.94v1.94c0 .202.158.37.36.37h.81c.202 0 .36-.168.36-.37v-1.94h1.94c.202 0 .37-.158.37-.36v-.04a.365.365 0 0 0-.37-.36h-1.94v-1.54h1.94c.202 0 .37-.168.37-.37v-.03a.373.373 0 0 0-.37-.37h-1.94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4 9a.8.8 0 0 1 .094 1.594l-.094.006h-.8v10.506l1.156-.772a.8.8 0 0 1 .796-.053l.092.053 1.156 1.304 1.956-1.304a.8.8 0 0 1 .796-.053l.092.053 1.956 1.304 1.156-1.304a.8.8 0 0 1 .796-.053l.092.053 1.156.772V10.6H21a.8.8 0 0 1-.094-1.594L21 9h1.6a.8.8 0 0 1 .794.706l.006.094v12.8a.8.8 0 0 1-1.16.714l-.084-.048-1.956-1.304-1.156 1.304a.8.8 0 0 1-.796.053l-.092-.053-1.956-1.304-1.956 1.304a.8.8 0 0 1-.796.053l-.092-.053-1.156-1.304-1.956 1.304a.8.8 0 0 1-1.238-.568L9 22.6V9.8a.8.8 0 0 1 .706-.794L9.8 9z"
  })))));
};
export default SvgPerCustomerPrice;